module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "test_mark"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/caution-sign.svg"),
      "alt": ""
    }
  }), _c('span', [_vm._v("Тест")]), _vm._v(" "), _c('div', {
    staticClass: "test_hint"
  }, [_vm._v("\n    Це тестовая версія. Маєте запитання чи пропозицію? "), _c('a', {
    attrs: {
      "href": "https://multiplex.ua/faq#support"
    }
  }, [_vm._v("Напишіть нам")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38f2635e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pop-ups/test-mark.vue
// module id = 295
// module chunks = 1